import { getDoorDistanceFromRight } from "./index132.js";
import { getDefaultAggRulesProps } from "./index154.js";
import { getActions } from "./index161.js";
import { RG_TYPE, getDefaultMix } from "@project-rouge/rg-core";
function getDataAndActions(aggRulesProps) {
	const { gap } = aggRulesProps.dataset.aggConfig;
	const allApartments = aggRulesProps.dataset.apartments.all;
	const smallestApartmentSize = gap + Math.min(...allApartments.map((a) => a.size[0]));
	const largestUnitSize = gap + Math.max(...allApartments.map((a) => a.size[0]), aggRulesProps.dataset.aggConfig.coreWithLifts.size[0]);
	const smallestNextToEntranceSize = gap + aggRulesProps.dataset.apartments.nextToEntrance.map((a) => a.size[0]).sort()[0];
	const defaultProps = getDefaultAggRulesProps(aggRulesProps.dataset);
	Object.keys(aggRulesProps).forEach((k) => {
		const key = k;
		if (aggRulesProps[key] === void 0) delete aggRulesProps[key];
	});
	const data = {
		...defaultProps,
		...aggRulesProps,
		smallestApartmentSize,
		largestUnitSize,
		minDoorPositionFromEnd: 0,
		smallestNextToEntranceSize
	};
	const actions = getActions(data);
	redefineTargetUnitMix(data);
	data.minDoorPositionFromEnd = Math.min(...actions.filter((a) => a.unit.type === RG_TYPE.Apartment).map((a) => getDoorDistanceFromRight(a)));
	return {
		data,
		actions
	};
}
function redefineTargetUnitMix(props) {
	const newTargetUnitMix = getDefaultMix(props.dataset);
	newTargetUnitMix.forEach((t) => {
		t.ratio = 0;
	});
	if (props.targetUnitMix) for (const t of props.targetUnitMix) {
		const category = newTargetUnitMix.find((nt) => nt.label === t.label);
		if (category) category.ratio = t.ratio;
	}
	props.targetUnitMix = newTargetUnitMix;
}
export { getDataAndActions };

//# sourceMappingURL=index162.js.map